import { render } from "./ComingSoonModal.vue?vue&type=template&id=402e1544&scoped=true"
import script from "./ComingSoonModal.vue?vue&type=script&lang=js"
export * from "./ComingSoonModal.vue?vue&type=script&lang=js"

import "./ComingSoonModal.vue?vue&type=style&index=0&id=402e1544&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402e1544"]])

export default __exports__